import { createReducer } from "@reduxjs/toolkit";
import { submitSelections } from "./actions";

interface Selection {
  index: number;
  value: string;
}

interface ComponentState {
  selections: Selection[];
}

interface DiagramQuestionState {
  [componentID: string]: ComponentState;
}

// Initial state
const initialState: DiagramQuestionState = {};

// Reducer
export const DiagramQuestionReducer = createReducer(initialState, (builder) => {
  builder.addCase(submitSelections, (state, action) => {
    const { componentID, selections } = action.payload;
    // Immer allows direct mutation of the state
    if (!state[componentID]) {
      state[componentID] = { selections: [] }; // Initialize if componentID doesn't exist
    }
    state[componentID].selections = selections;
  });
});
